import { useIntl } from "react-intl";

export function useFirmwareProperties() {
  const { formatMessage } = useIntl();

  const statusValues = new Map<number, string>();
  statusValues.set(-1, formatMessage({ defaultMessage: "Unknown" }));
  statusValues.set(0, formatMessage({ defaultMessage: "Beta" }));
  statusValues.set(1, formatMessage({ defaultMessage: "Published" }));
  statusValues.set(2, formatMessage({ defaultMessage: "Stable" }));
  statusValues.set(3, formatMessage({ defaultMessage: "Obsolete" }));
  statusValues.set(4, formatMessage({ defaultMessage: "Deleted" }));

  const urgencyValues = new Map<number, string>();
  urgencyValues.set(0, formatMessage({ defaultMessage: "Low" }));
  urgencyValues.set(1, formatMessage({ defaultMessage: "Normal" }));
  urgencyValues.set(2, formatMessage({ defaultMessage: "Urgent" }));
  urgencyValues.set(3, formatMessage({ defaultMessage: "Immediately" }));

  return { statusValues, urgencyValues };
}
